import script from "./FightScreen.vue?vue&type=script&lang=js&setup=true"
export * from "./FightScreen.vue?vue&type=script&lang=js&setup=true"

import "./FightScreen.vue?vue&type=style&index=0&id=bf034a4c&lang=css"

const __exports__ = script;

export default __exports__